import styled from 'styled-components';

export const CardInfo = styled.div`
  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

// Hosted iframe rendering the legacy VirtualCard (269x170) plus the three
// card-detail rows below it; min-width keeps the fixed-width card unclipped
// and max-width matches the section column on desktop
export const CardDetailsFrame = styled.iframe`
  width: 100%;
  min-width: 269px;
  max-width: 285px;
  height: 290px;
  border: none;
`;
